var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mk-image",attrs:{"draggable":"false","src":_vm.tempValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }